import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../../../app/frontend/components/components/utils/formatDate';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const PendingEvent = ({ offer: { timelines, user_offer:userOffer, event_title, event_description, event_address } }) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (!userOffer) return <div></div>;

  return (
    <React.Fragment>
      {breakpoint !== 'xs' ?
        <h3 className="mb-4-5">{event_title || 'Event'}</h3> :
        <h4 className="mb-4-5">{event_title || 'Event'}</h4>
      }
      <p dangerouslySetInnerHTML={{ __html: event_description }} />
      <div className="text-3">
        {t('influencers.pages.campaign.event_date')}
      </div>
      <p className="text-medium-1">
        {formatDate(timelines.event, { withTime: true })}
      </p>
      <div className="text-3">
        {t('influencers.pages.campaign.event_address')}
      </div>
      <p className="text-medium-1" dangerouslySetInnerHTML={{ __html: event_address }} />
    </React.Fragment>
  );
};

PendingEvent.propTypes = {
  offer: PropTypes.object.isRequired
};

export default PendingEvent;
